'use client';

import React from 'react';
import { AvailableCartLevelGifts } from '@kidslabs/module-flash-sale';
import type { GiftSelectionPromptProps } from './gift-selection-prompt.types';

/**
 * GiftSelectionPrompt - Displays cart-level gift selection prompt
 * Matches mobile module-theme-hermes implementation using AvailableCartLevelGifts from module-flash-sale
 */
export const GiftSelectionPrompt: React.FC<GiftSelectionPromptProps> = ({ onGiftSelectionPromptPress, isMobile }) => {
    return (
        <AvailableCartLevelGifts variant="compact" onCartPromptPress={onGiftSelectionPromptPress} isMobile={isMobile} />
    );
};
